import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientListComponent } from './clients-list/clients-list.component';
import { ClientComponent } from './clients-add-update/clients-add-update.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [],
    declarations: [
        ClientListComponent,
        ClientComponent
    ],
    providers: [],
})
export class ClientsModule { }
